import type { AlchemyType } from '@/domain/genetics/types';

/**
 * Matriz de vantagem elemental (BR-U5-05).
 * attacker → defender = multiplicador de dano.
 */
const ADVANTAGE: Record<AlchemyType, AlchemyType> = {
  Fire: 'Life',
  Water: 'Fire',
  Earth: 'Air',
  Air: 'Earth',
  Life: 'Water',
  Shadow: 'Life',
};

const DISADVANTAGE: Partial<Record<AlchemyType, AlchemyType>> = {
  Fire: 'Water',
  Water: 'Earth',
  Earth: 'Life',
  Air: 'Fire',
  Life: 'Shadow',
  // Shadow não tem desvantagem fixa
};

export const ADVANTAGE_MULTIPLIER = 1.25;
export const DISADVANTAGE_MULTIPLIER = 0.75;
export const NEUTRAL_MULTIPLIER = 1.0;

export function elementalMultiplier(
  attackerType: AlchemyType,
  defenderType: AlchemyType,
): number {
  if (ADVANTAGE[attackerType] === defenderType) return ADVANTAGE_MULTIPLIER;
  if (DISADVANTAGE[attackerType] === defenderType) return DISADVANTAGE_MULTIPLIER;
  return NEUTRAL_MULTIPLIER;
}
